export default "images/error_red.png";